import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const userTemplate = {
  cif: null,
  creditLimit: null,
  documentType: null,
  followupStatus: null,
  fullName: null,
  historyUploads: null,
  loanAppId: null,
  productName: null,
  productType: null,
  marketCode: null,
  sumitDate: null,
  isDocumentType: null,
  token: null,
  uploadMessages: null,
  grpId: null
}

export const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  state: {
    userData: { ...userTemplate },
    isLoading: false
  },
  mutations: {
    setUserData(state, userData) {
      state.userData = userData;
    },
    clearUserData(state) {
      state.userData = { ...userTemplate };
    },
    setToken(state, token) {
      state.userData.token = token;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    }
  },
  actions: {
    setUserData({ commit }, userData) {
      commit('setUserData', userData);
    },
    clearUserData({ commit }) {
      commit('clearUserData');
    },
    setToken({ commit }, token) {
      commit('setToken', token);
    },
    setIsLoading({ commit }, isLoading) {
      commit('setIsLoading', isLoading);
    }
  },
  getters: {
    getUserData(state) {
      return state.userData;
    },
    getToken(state) {
      return state.userData.token;
    },
    getIsLoading(state) {
      return state.isLoading;
    }
  }
});
